<template>
  <div
    class="group flex bg-primary hover-bg-primary_hover border-b border-b-secondary select-none cursor-pointer px-4 py-3 h-fit"
    :class="{
      'ltr:border-l-6 ltr:md:border-l-4 ltr:border-l-error rtl:border-r-6 rtl:md:border-r-4 rtl:border-r-error ltr:pl-2.5 ltr:md:pl-3 rtl:pr-2.5 rtl:md:pr-3':
        overdue,
    }"
  >
    <div class="w-full flex flex-col justify-start">
      <div class="flex gap-x-4 mb-2">
        <TextWithTooltip
          :title="task.description"
          :listeners="[width]"
          :lines="2"
          side="bottom"
        />
        <DueDate
          :dueDate="task.completed_at || task.scheduled_for"
          :isOverdue="overdue"
          :size="maxSmall ? 'md' : 'sm'"
          class="whitespace-nowrap h-6 flex items-center"
        />
      </div>
      <div class="flex w-full grow flex-col">
        <div class="flex gap-x-1 gap-y-2 items-center shink-0 grow max-w-full">
          <Recurring v-if="!!task.recurrence" :size="maxSmall ? 'md' : 'sm'" />
          <Visibility
            :isPrivate="!!task.problem?.is_private"
            :iconOnly="true"
            :size="maxSmall ? 'md' : 'sm'"
          />
          <Divider orientation="vertical" class="h-5.5" />
          <Priority
            :priority="task.priority?.id"
            :iconOnly="true"
            :variant="maxSmall ? 'dark' : 'light'"
            :size="maxSmall ? 'md' : 'sm'"
          />
          <CategoryWithTooltip
            v-if="task.category"
            :category="task.category"
            :listeners="[width]"
            side="bottom"
          />
          <Divider orientation="vertical" class="h-5.5" />
          <Assignees
            :assignees="task.assignees"
            :size="maxSmall ? 'md' : 'sm'"
            :show-names="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import { Visibility, Priority, Recurring } from "@/SharedComponents/Badges";
import { DueDate } from "@/SharedComponents/Dates";
import { Assignees } from "@/SharedComponents/Assignees";
import { Divider } from "@/SharedComponents/Divider";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { TextWithTooltip } from "@/SharedComponents/TextWithTooltip";
import { CategoryWithTooltip } from "@/SharedComponents/CategoryWithTooltip";

const props = defineProps({
  task: { type: Object, required: true },
});

const { maxSmall, width } = useBreakpoints();

const overdue = computed(() => {
  if (!props.task.scheduled_for) return false;
  if (props.task.completed_at) return false;

  return Date.now() > new Date(props.task.scheduled_for);
});
</script>
